import { internalFetch } from '../utils/fetchHelper';
import { IPagedCollection } from '@moko/utils';

export interface IQrCode {
  assetId: number;
  createdAt?: string;
  data: string;
  id: number;
}

export interface IQrCodesTemplate {
  id: number;
  name: string;
  content: string;
  version: string;
  entityType: string;
  isActive: boolean;
}

export interface IStoreQrCodeResponse {
  id: number;
  version: number;
  isActive: boolean;
}

export interface IRestoreQrCodeResponse {
  id: number;
  version: number;
  isActive: boolean;
  content: string;
}

export enum QrCodeEntityTypes {
  Asset,
  Zone,
}

export const getQrCodesTemplates = async (
  abortController: AbortController,
  entityType: string,
  pageSize: number,
  pageNo: number,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<IQrCodesTemplate>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/qrCodeTemplates?pageSize=${pageSize}&pageNo=${pageNo}&entityType=${entityType}${
      orderBy ? `&orderBy=${orderBy}` : ''
    }${search ? `&search=${search}` : ''}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const storeQrCodeTemplate = async (
  abortController: AbortController,
  entityType: string,
  content: string,
  isActive: boolean,
  name?: string
): Promise<IStoreQrCodeResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/qrCodeTemplate?code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'POST',
    abortController,
    JSON.stringify({
      entityType: entityType,
      name: name,
      isActive: isActive,
      content: content,
    })
  );
};

export const deleteQrCodeTemplate = async (
  abortController: AbortController,
  templateId: number
): Promise<IStoreQrCodeResponse> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/qrCodeTemplate?templateId=${templateId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'DELETE',
    abortController
  );
};

export const activeQrCodeTemplate = async (
  abortController: AbortController,
  templateId: number
): Promise<IStoreQrCodeResponse> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/activeQrCodeTemplate?templateId=${templateId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController
  );
};

export const restoreQrCodeTemplate = async (
  abortController: AbortController,
  templateId: number
): Promise<IRestoreQrCodeResponse> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/qrCodeTemplate?templateId=${templateId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getQrCodes = async (
  abortController: AbortController,
  entity: QrCodeEntityTypes,
  pageSize: number,
  pageNo: number
): Promise<IPagedCollection<IQrCode>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/qrcodes/${entity}/?pageSize=${pageSize}&pageNo=${pageNo}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const getQrCodesDoc = async (
  abortController: AbortController,
  entity: QrCodeEntityTypes
): Promise<Response> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/qrcodesdoc/${entity}`,
    'GET',
    abortController,
    undefined,
    true
  );
};

export const getQrCodesPng = async (
  abortController: AbortController,
  entity: QrCodeEntityTypes
): Promise<Response> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/qrcodespng/${entity}`,
    'GET',
    abortController,
    undefined,
    true
  );
};
